/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/
/** PURE_IMPORTS_START _roaming_stepper.component.scss.shim.ngstyle,_angular_core,_roaming_stepper.component PURE_IMPORTS_END */
/** PURE_IMPORTS_START _roaming_stepper.component.scss.shim.ngstyle,_angular_core,_roaming_stepper.component PURE_IMPORTS_END */
import * as i0 from "./roaming-stepper.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./roaming-stepper.component";
var styles_RoamingStepperComponent = [i0.styles];
var RenderType_RoamingStepperComponent = /*@__PURE__*/ i1.ɵcrt({ encapsulation: 0, styles: styles_RoamingStepperComponent, data: {} });
export { RenderType_RoamingStepperComponent as RenderType_RoamingStepperComponent };
export function View_RoamingStepperComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 3, "ul", [["class", "mod mod-stepper"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["\n    "])), i1.ɵncd(null, 0), (_l()(), i1.ɵted(-1, null, ["\n"])), (_l()(), i1.ɵted(-1, null, ["\n"]))], null, null); }
export function View_RoamingStepperComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 2, "roaming-stepper", [], null, null, null, View_RoamingStepperComponent_0, RenderType_RoamingStepperComponent)), i1.ɵdid(1, 1097728, null, 1, i2.RoamingStepperComponent, [], null, null), i1.ɵqud(603979776, 1, { items: 1 })], null, null); }
var RoamingStepperComponentNgFactory = /*@__PURE__*/ i1.ɵccf("roaming-stepper", i2.RoamingStepperComponent, View_RoamingStepperComponent_Host_0, {}, {}, ["*"]);
export { RoamingStepperComponentNgFactory as RoamingStepperComponentNgFactory };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/roaming-stepper/roaming-stepper.component.ngfactory.js
// module id = null
// module chunks = 